import ReactECharts from 'echarts-for-react';

interface IProps {
    grid: IGrid;
    seriesData: any;
    xAxis?: any;
    yAxisData?: any;
    title?: string;
}

interface IGrid {
    top: string|number,
    bottom: string|number,
    left: string|number,
    right: string|number
}

const EChart = ({ grid, seriesData, xAxis, yAxisData, title }: IProps) => {
    const options = {
        title: {
            show: false,
            title: title
        },
        color: ['#36A8DE', '#38A935', '#ACC0E8', '#88CB86'],
        legend:{
            top: '20',
            itemStyle: {
                color: 'inherit'
            },
            textStyle: {
                color: '#fff'
            }
        },
        grid: grid,
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        toolbox: {
            feature: {
                dataView: { show: true, readOnly: true },
                saveAsImage: { show: true, name: title, backgroundColor: '#595957' }
            }
        },
        xAxis: xAxis,
        yAxis: yAxisData,
        series: seriesData
    };

    return (
        <ReactECharts option={options} className='h-100' />
    );
};

export default EChart;